<template>
  <div class="serverStatus">
    <OverlayWindow v-show="!reestablished">
      <template v-slot:title>Perdido o contacto com o servidor</template>
      <p>Tal pode acontecer por breves minutos durante actualizações ao software do servidor.</p>
      <p>Se o problema persistir entre em contacto com a assistência técnica.</p>
      <p><Loading :inline="true" text="A tentar restabelecer ligação ao servidor" /></p>
      <template v-slot:actions> &nbsp; </template>
    </OverlayWindow>
    <OverlayWindow v-show="reestablished">
      <template v-slot:title>Contacto Reestabelicido</template>
      <!--p class="big"><img src=""><img src="/img/back-online.webp" alt=""/></p-->
      <p>A ligar...</p>
      <template v-slot:actions> &nbsp; </template>
    </OverlayWindow>
  </div>
</template>

<script>
import OverlayWindow from '../OverlayWindow/OverlayWindow.vue'
import { axios } from '../../request'
import Loading from '../LoadingC.vue'

export default {
  name: 'ServerStatus',
  data() {
    return {
      reestablished: false,
      counterFunction: null,
      counterValue: 3,
      mode: import.meta.env.VITE_MODE,
    }
  },
  components: { OverlayWindow, Loading },
  methods: {
    count() {
      if (this.counterValue === 0) {
        axios
          .get()
          .then(() => {
            this.reestablished = true
            setTimeout(() => {
              if (this.mode != 'local') {
                location.reload()
              } else {
                this.$store.dispatch('serverStatus', 'ok')
              }
            }, 500)
          })
          .catch(() => {
            this.counterValue = 3
          })
      } else {
        this.counterValue -= 1
      }
    },
  },
  mounted() {
    this.counterFunction = setInterval(this.count, 1000)
  },
  unmounted() {
    clearInterval(this.counterFunction)
  },
}
</script>

<style lang="scss" scoped>
.big {
  font-size: 64px;
  margin: 24px;
}
</style>
>
